import ReferenceArrayInputController from './ReferenceArrayInputController';
import ReferenceInputController from './ReferenceInputController';
export { ReferenceArrayInputController, ReferenceInputController };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/controller/input/index.js
// module id = 1150
// module chunks = 0